import BaseIntegration from '@/common/mixins/integrations/baseIntegration';

const KuwaitZainIntegrationMixin = {
  extends: BaseIntegration,
  methods: {
    getPreRegistrationRedirectionActionImpl() {
      return () => {
        window.location.href = `${window.location.origin}/publicapi/heCheckRedirection?lang=${this.getLocale}&refUrl=${this.getRefUrl || ''}&clickid=${this.getClickId || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`;
      };
    },
    checkIfIsOnly2Step() {
      return true;
    },
  },
};

export default KuwaitZainIntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/kuwaitZainIntegration.js